import React, { useState, useEffect } from "react";
import UserSection from "../../Services/User/UserLogin";
import UserTopbar from "../UserTopbar";
import axios from "axios";
import Loader from "../utils/Loader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import DownloadSummary from "./DownloadSummary";
import { CircularProgress } from "@mui/material";
import drive from "../../../src/SliderImage/drive.png";
import editImg from "../../../src/SliderImage/edit.png";
import excelImg from "../../../src/SliderImage/excel.png";
import pdfImg from "../../../src/SliderImage/pdf.png";
import Apiurl from "../../Helpers/apiUrl";
import { usePdf } from "../context/pdfContext";
import { formatCurrency, getCurrencySymbol } from "../../Helpers/currencyHelper";

const ViewProjects = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const project_id = params.get("project_id");
  const myStyles = {
    // display: 'flex',
    // justifyContent: 'center',
    // border:'1px solid #D3D3D3',
    // borderBottom: '1px solid #D3D3D3',
  };
  const [projectId, setprojectId] = useState(project_id);
  const [projectData, setprojectData] = useState();
  const [projectSection, setSection] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  const [sectionTotal, setSectionTotal] = useState(0);
  const [sectionId, setSectiionId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [button, setButton] = useState("Download Excel");
  const [disable, setDisable] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const { isSidebarOpen } = useOutletContext();
  const [excelData, setExcelData] = useState(null);
  const { downloadPdf } = usePdf();

  const viewprojectById = async () => {
    try {
      setLoading(true);
      let res = await UserSection.viewProjectById(projectId);
      if (res.status) {
        setLoading(false);
        const sectionsArray = Object.entries(res.data.section);
        setSectionArr(sectionsArray);
        setprojectData(res.data);
        setSectionTotal(Object.keys(res.data.section).length);
      } else {
        return 0;
      }
    } catch (error) {
      setLoading(true);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const resetstate = (e) => {
    setLoading(false);
    e.preventDefault();
    setprojectId("");
    setSectionArr();
    setSectionTotal();
    setprojectData();
  };
  useEffect(() => {
    viewprojectById();
  }, []);

  const formatNumber = (value) => {
    let val = value ? value : 0;

    if (typeof val === "string") {
      val = val.replace(/,/g, "");
    }

    val = parseFloat(val);

    // return val.toFixed(1);
    return parseFloat(val.toFixed(1)).toLocaleString("en-IN");
  };

  const formatNoDecimal = (value) => {
    let val = value ? value : 0;
    if (typeof val === "string") {
      val = val.replace(/,/g, "");
    }

    val = parseFloat(val);

    val = Math.round(val);

    return val;
    // return parseFloat(val.toFixed(1)).toLocaleString('en-IN');
  };

  const [dataFromDownloadSummary, setDataFromDownloadSummary] = useState("");
  const [showComponent, setshowComponent] = useState(false);
  const [excelloading, setExcelLoading] = useState(false);
  const [projectIdDownload, setProjectIdDownload] = useState();

  const handleDataFromDownloadSummary = (data) => {
    // console.log("data from child" + data);
    setDataFromDownloadSummary(data);
  };

  useEffect(() => {
    if (
      dataFromDownloadSummary == "downloaded" ||
      dataFromDownloadSummary == "failed"
    ) {
      setExcelLoading(false);
    }
  }, [dataFromDownloadSummary]);

  const [loadingId, setLoadingId] = useState(false);

  const editProject = async (row) => {
    try {
      setLoadingId(true);
      const token = localStorage.getItem("u_token");

      const response = await axios.get(
        `${Apiurl}project/summary/project/${row.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const selectionDetails = response.data?.data || [];
      const quoteDetails = {
        ...(response.data?.client ?? {}),
        gstType: response.data.data?.client?.gst != 0 ? 'INC' : 'EXC'
      };

      navigate(
        `/user/create-quote/${row.client_id}/${encodeURIComponent(row?.client?.client_name)}/${row.id}`,
        { state: { selectionDetails, quoteDetails } }
      );

    } catch (error) {
      console.error("Failed to fetch project summary:", error);
    } finally {
      setLoadingId(false);
    }
  };

  return (
    <>
      <div>
        {excelloading && <Loader />}
        <UserTopbar heading="View Projects" sidebar={isSidebarOpen} />
        <div className="p-2">
          {error && <p className="text-red-500 text-center">{error}</p>}

          <div className="relative ">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {/* Client ID */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="flex justify-between mb-2">
                  <div className="text-white text-sm font-medium">
                    Client ID
                  </div>
                  <div className="text-white text-sm font-medium">
                    Client Name
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm font-medium ">
                    {projectData ? projectData.client_id : "N/A"}
                  </div>
                  <div className="text-white text-sm font-medium ">
                    {projectData ? projectData.client.client_name : "N/A"}
                  </div>
                </div>
              </div>

              {/* Client Name */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="flex  mb-2">
                  <div className="text-white text-sm font-medium">Phone :</div>
                  <div className="text-white text-sm ml-2 font-semibold">
                    {projectData ? projectData.client.phone : "N/A"}
                  </div>
                </div>
                <div className="flex ">
                  <div className="text-white text-sm font-medium">Email :</div>
                  <div className="text-white text-sm ml-2 font-semibold">
                    {projectData ? projectData.client.email : "N/A"}
                  </div>
                </div>
              </div>

              {/* Billing Address */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="text-white text-sm font-medium mb-2">
                  Billing Address
                </div>
                <div className="text-white text-sm font-medium ">
                  {projectData ? projectData.client.site_add : "N/A"}
                </div>
              </div>

              {/* Architect Firm Detail */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="text-white text-sm font-medium mb-2">
                  Architect Firm Detail
                </div>
                <div className="text-white text-sm font-medium ">
                  {projectData ? projectData.client.afd : "N/A"}
                </div>
              </div>

              {/* Site Address */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="text-white text-sm font-medium mb-2">
                  Site Address
                </div>
                <div className="text-white text-sm font-medium ">
                  {projectData ? projectData.client.add_to : "N/A"}
                </div>
              </div>

              {/* Project ID */}
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="text-white text-sm font-medium mb-2">
                  Project ID
                </div>
                <div className="text-white text-sm font-medium ">
                  {projectData ? projectData.project_id : "N/A"}
                </div>
              </div>
              <div className="bg-gray-900 border border-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-105">
                <div className="flex justify-between text-white text-sm font-medium mb-2">
                  <div>Date:</div>
                  <div>Valid Date:</div>
                </div>
                <div className="text-white text-sm font-medium  flex justify-between">
                  <div className="">
                    {projectData
                      ? new Date(projectData.created_at).toLocaleDateString(
                        "en-GB"
                      )
                      : "N/A"}
                  </div>
                  <div className="">
                    {projectData
                      ? new Date(projectData.valid_date).toLocaleDateString(
                        "en-GB"
                      )
                      : "N/A"}
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center gap-10">
                {/* Download Button */}
                <span className="flex flex-col gap-2">
                  <Link to={"/user/project/download"}>
                    <img
                      src={excelImg}
                      alt="Google Drive"
                      width={38}
                      className="transition-transform transform hover:scale-110"
                    />
                  </Link>
                  <button
                    onClick={async () => {
                      downloadPdf(projectData?.project_id, `${Apiurl}user/downloadPdf`);
                      try {
                        const token = localStorage.getItem("u_token");

                        await axios.post(
                          `${Apiurl}project/download-status/${projectData?.project_id}`,
                          { pdfCount: 1 },
                          {
                            headers: {
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        );
                      } catch (statusError) {
                        console.error("Failed to update download status", statusError);
                      }


                    }}
                  >
                    <img
                      src={pdfImg}
                      alt="pdf"
                      width={38}
                      className="transition-transform transform hover:scale-110"
                    />
                  </button>
                </span>
                <div className="flex flex-col gap-2">
                  <button onClick={() => editProject(projectData)}>
                    {loadingId ? (
                      <CircularProgress size={16} style={{ color: "white" }} />
                    ) : (
                      <img
                        src={editImg}
                        alt="edit"
                        width={38}
                        className="transition-transform transform hover:scale-110"
                      />
                    )}

                  </button>
                  <a
                    href="https://drive.google.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={drive}
                      alt="Google Drive"
                      width={38}
                      className="transition-transform transform hover:scale-110"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto mt-6 rounded-lg border border-gray-300 shadow-md max-h-[600px] overflow-y-auto">
            <table className="min-w-[1400px] w-full text-sm border-collapse border border-slate-400">
              <thead className="bg-gray-900 text-white">
                <tr>
                  {[
                    "Sr.No",
                    // "HSN Code",
                    "Product Code",
                    "Area",
                    "Brand",
                    "Product Description",
                    "Collection",
                    "Type",
                    "Category",
                    "Price Segment",
                    // "Spare/FG",
                    "Finish",
                    "Preferences",
                    "Image",
                    "Qty",
                    `MRP (${getCurrencySymbol()})`,
                    `Base (${getCurrencySymbol()})`,
                    "Disc %",
                    `Disc/Unit (${getCurrencySymbol()})`,
                    `Offer / Unit (${getCurrencySymbol()})`,
                    "GST/VAT %",
                    `Total Disc (${getCurrencySymbol()})`,
                    `Total (${getCurrencySymbol()})`,
                  ].map((heading, index) => (
                    <th
                      key={index}
                      className={`border min-w-[140px] border-slate-600 px-4 py-2 sticky top-0 z-10 bg-gray-900 ${heading === "Product Description"
                        ? "text-left"
                        : "text-center"
                        }`}
                    >
                      {heading}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white">
                {loading && (
                  <tr>
                    <td colSpan="21" className="text-center py-10">
                      <Loader />
                    </td>
                  </tr>
                )}

                {sectionArr.map(([sectionName, items], sectionIndex) => {
                  let sectionTotalMRP = 0;
                  let sectionOfferPrice = 0;
                  let shower = 0,
                    basin = 0,
                    ewc = 0,
                    kitchen = 0,
                    faucets = 0;

                  return (
                    <React.Fragment key={sectionIndex}>
                      <tr>
                        <td
                          colSpan="21"
                          className="bg-gray-100 text-gray-800 font-semibold px-4 py-2 text-lg text-center border"
                        >
                          {items[0]?.section_name}
                        </td>
                      </tr>

                      {items.map((item, idx) => {
                        const basePrice = Number(item.unit || 0);
                        const gst = Number(item.gst || 0);

                        // Calculate MRP including GST
                        const mrp = basePrice + (basePrice * gst) / 100;

                        const mrpTotal = mrp * Number(item.qty || 0);
                        // const mrpTotal = item.product_attr?.mrp * item?.qty;
                        sectionTotalMRP += mrpTotal;
                        sectionOfferPrice += item.total;

                        // shower += item.shower_area || 0;
                        // basin += item.Basin || 0;
                        // ewc += item.Ewc || 0;
                        // kitchen += item.kitchen || 0;
                        // faucets += item.faucets || 0;

                        const itemArea = (item.area || "").trim().toLowerCase();
                        const itemTotal = Number(item.total || 0);

                        if (itemArea === "shower") {
                          shower += itemTotal;
                        } else if (itemArea === "basin") {
                          basin += itemTotal;
                        } else if (itemArea === "ewc") {
                          ewc += itemTotal;
                        } else if (itemArea === "kitchen") {
                          kitchen += itemTotal;
                        } else if (itemArea === "faucet" || itemArea === "faucets") {
                          faucets += itemTotal;
                        }

                        const isGstZero = item.gst == 0 || item.gst == 0.00 || !item.gst;
                        const offerUnit = isGstZero
                          ? Number(item.unit || 0) - Number(item.disc_price || 0)
                          : Number(mrp || 0) - Number(item.disc_price || 0);

                        return (
                          <tr key={idx} className="hover:bg-gray-50 transition">
                            <td className="border px-3 py-2 text-center">
                              {idx + 1}
                            </td>
                            {/* <td className="border px-3 py-2 text-center">
                              {item.product_attr.hsnCode}
                            </td> */}
                            <td className="border px-3 py-2 text-center">
                              {item.sku_code}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.area?.toUpperCase()}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.brand}
                            </td>
                            <td className="border px-3 py-2 text-left min-w-[240px]">
                              {item.product_attr?.product_desc}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.collection}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.product_typ_group}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.category}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.priceSegment}
                            </td>

                            {/* <td className="border px-3 py-2 text-center">
                              {item.product_attr.spare_fg}
                            </td> */}

                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.finish}
                            </td>

                            <td className="border px-3 py-2 text-center">
                              {item.product_attr?.preferences}
                            </td>

                            <td className="border px-3 py-2 text-center">
                              <img
                                src={item.product_attr?.image || item.product_view_attr?.image || item.image || item.img}
                                className="w-16 h-auto mx-auto"
                                alt="Product"
                              />
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.qty}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {formatCurrency(mrp)}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {formatCurrency(item.unit)}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {formatNumber(item.disc_per)}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {formatCurrency(item.disc_price)}
                            </td>
                            <td className="border px-3 py-2 text-center font-medium text-blue-600">
                              {formatCurrency(offerUnit)}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {item.gst || 0}
                            </td>
                            <td className="border px-3 py-2 text-center">
                              {formatCurrency(parseFloat(item.disc_price) * parseFloat(item.qty))}
                            </td>
                            <td className="border px-3 py-2 text-center text-blue-600">
                              {formatCurrency(item.total)}
                            </td>
                          </tr>
                        );
                      })}

                      {/* Subtotal Rows */}
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          List Price: {formatCurrency(sectionTotalMRP)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          Offer Price: {formatCurrency(sectionOfferPrice)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          Shower Area Offer Price: {formatCurrency(parseFloat(shower))}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          Basin Area Offer Price: {formatCurrency(basin)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          EWC Area Offer Price: {formatCurrency(ewc)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          Kitchen Area Offer Price: {formatCurrency(kitchen)}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan="21"
                          className="border px-3 py-2 text-right font-semibold bg-gray-50"
                        >
                          Faucets Area Offer Price: {formatCurrency(faucets)}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style={{ display: showComponent ? "block" : "none" }}>
        <DownloadSummary
          project={projectIdDownload}
          sendData={handleDataFromDownloadSummary}
        />
      </div>
    </>
  );
};

export default ViewProjects;
